export enum FolderPermission {
  Public = 'public',
  Private = 'private',
  ReadOnly = 'read-only',
}
